import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { Link } from 'react-router-dom';
import { Formik } from 'formik';
import PropTypes from 'prop-types';
import IconClose from 'components/icons/iconClose';
import IconArrowRight from 'components/icons/iconArrowRight';
import ShowroomLocatorResults from 'components/consumer/consumer-new-footer/components/ShowroomLocatorResults';
import useShowroomLocator, { validateZipcodeInput } from 'hooks/useShowroomLocator';
const MobileNavbarShowroomLocator = t0 => {
  const $ = _c(24);
  const {
    onClose,
    variant: t1
  } = t0;
  const variant = t1 === undefined ? "popover" : t1;
  const {
    stores,
    loading,
    error,
    hasSearched,
    handleSearch,
    handleCloseResults,
    handleViewAll
  } = useShowroomLocator();
  const isInMenu = variant === "inMenu";
  const containerClassName = isInMenu ? "w-full px-5 py-3 font-bold [&_a]:!text-brand [&_a]:!underline" : "w-72 px-4 py-3 font-bold [&_a]:!text-brand [&_a]:!underline";
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="text-gray font-bold text-base">Find your closest showroom</div>;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== isInMenu || $[2] !== onClose) {
    t3 = !isInMenu && onClose && <button type="button" onClick={onClose} className="text-gray p-1" aria-label="Close"><IconClose width={12} height={12} /></button>;
    $[1] = isInMenu;
    $[2] = onClose;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <div className="flex justify-between items-center mb-2">{t2}{t3}</div>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      zipcode: ""
    };
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== handleSearch) {
    t6 = <Formik initialValues={t5} validate={validateZipcodeInput} onSubmit={t7 => {
      const {
        zipcode
      } = t7;
      handleSearch(zipcode);
    }}>{_temp}</Formik>;
    $[7] = handleSearch;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="text-xs text-gray font-normal my-2">Within 50 miles</div>;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== error || $[11] !== handleCloseResults || $[12] !== hasSearched || $[13] !== loading || $[14] !== stores) {
    t8 = hasSearched && <ShowroomLocatorResults loading={loading} error={error} stores={stores} onClose={handleCloseResults} isMobile={true} />;
    $[10] = error;
    $[11] = handleCloseResults;
    $[12] = hasSearched;
    $[13] = loading;
    $[14] = stores;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== handleViewAll) {
    t9 = <div className="mt-3"><Link to="/showrooms/" onClick={handleViewAll} className="text-brand underline text-sm !font-semibold">View All</Link></div>;
    $[16] = handleViewAll;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== containerClassName || $[19] !== t4 || $[20] !== t6 || $[21] !== t8 || $[22] !== t9) {
    t10 = <div className={containerClassName} data-testid="mobile-hamburger-store-locator">{t4}{t6}{t7}{t8}{t9}</div>;
    $[18] = containerClassName;
    $[19] = t4;
    $[20] = t6;
    $[21] = t8;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  return t10;
};
MobileNavbarShowroomLocator.propTypes = {
  onClose: PropTypes.func,
  variant: PropTypes.oneOf(['popover', 'inMenu'])
};
export default MobileNavbarShowroomLocator;
function _temp(t0) {
  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleSubmit
  } = t0;
  return <form onSubmit={handleSubmit}><div className="flex items-stretch"><input id="mobile-navbar-showroom-zipcode" name="zipcode" type="text" placeholder="Zip Code" value={values.zipcode} onChange={handleChange} onBlur={handleBlur} maxLength="5" autoComplete="postal-code" className="flex-1 border border-gray-light5 px-3 py-2 text-lg outline-none focus:border-brand" /><button type="submit" className="bg-brand text-white px-3 flex items-center justify-center [&_path]:fill-white" aria-label="Search"><IconArrowRight width={16} height={10} /></button></div>{touched.zipcode && errors.zipcode && <div className="text-red text-xs mt-1">{errors.zipcode}</div>}</form>;
}